const namespace = 'auth';

import { Component, Vue } from 'vue-property-decorator'

//Vuex
import { Action, Getter } from 'vuex-class';

//molds
import { Form, Input } from '@/components/wrappers/molds/Form';

//components
import PublicContent from '@/components/publicContent/PublicContent.vue'

//classes
import { Alert } from '@/services/notification'

//wrappers
import { WForm, WButton, WSubtitle, Box, Loader, SizedBox } from '@/components/wrappers';

import { setToken } from '@/services/api'

@Component({
	components: {
		PublicContent,
		SizedBox,
		WForm,
		WButton,
		WSubtitle,
		Box, Loader,
	}
})

export default class Login extends Vue {

	@Action('auth', { namespace }) dispathLogin: any;
	@Getter('error', { namespace }) loginError!: any;

	alert = new Alert(this.$store)

	isLoading = false

	dispatchForm(dataForm: Input[]): void {
		// setToken('teste');
		// this.$router.push('/')
		// return;
		this.isLoading = true
		this.dispathLogin(dataForm).then(() => {
			if (this.loginError == false) {
				this.alert.success("Loguin efetuado com sucesso!")
				this.$router.replace("/")
			} else if (this.loginError == 403) {
				this.alert.danger("Credeciais inválidas")
				this.isLoading = false
			} else if (this.loginError == 5000) {
				this.alert.danger("Desculpe ocorreu um erro: 5000")
				this.isLoading = false
			} else {
				this.alert.danger("Erro Inesperado! :(")
				this.isLoading = false
			}
		})
	}
	get form(): Form {
		return {
			flex: false,
			indent: true,
			grid: [
				[
					{
						fieldName: "username",
						label: "Email",
						type: "email",
						maxlength: 50,
						placeholder: "seu email",
						required: true,
					}
				],
				[
					{
						fieldName: "password",
						label: "Senha",
						type: "password",
						maxlength: 50,
						placeholder: "sua senha",
						required: true,
						passwordReveal: true
					}
				],
			]
		}
	}

	onRecovery(dataForm: Input[]): void {
		console.log("onRecovery");		
	}

	get formRecovery(): Form {
		return {
			flex: false,
			indent: true,
			grid: [
				[
					{
						fieldName: "username",
						label: "Email",
						type: "email",
						maxlength: 50,
						placeholder: "seu email",
						required: true,
						value: "oyrafael@gmail.com"
					}
				],
			]
		}
	}
	clickBtnRecovery(): void {
		this.$router.push("/?recovery=true")
		this.$forceUpdate()
	}

	clickBtnLogin(): void {
		this.$router.push("/?recovery=false")
	}

}
